let djotPromise: Promise<any> | null = null

function loadDjot(): Promise<any> {
  if (!djotPromise) {
    djotPromise = import(/* @vite-ignore */ 'https://esm.run/@djot/djot').then(
      (mod: any) => mod.default ?? mod
    )
  }
  return djotPromise
}

export function normalizeWikiDTag(input: string): string {
  return input
    .toLowerCase()
    .replace(/[ \t\r\n]+/g, '-')
    .replace(/[\][~!@#$%^&*(){}`,.<>\\|=+/?]+/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export async function renderDjotToHtml(content: string): Promise<string> {
  const { parse, renderHTML } = await loadDjot()
  const doc = parse(content) as any

  resolveWikilinks(doc)
  stripNostrSchemes(doc)

  return renderHTML(doc) as string
}

function stripNostrSchemes(doc: any) {
  for (const key in doc.references) {
    const ref = doc.references[key]
    if (ref?.destination && ref.destination.startsWith('nostr:')) {
      ref.destination = ref.destination.slice(6)
    }
  }
  walk(doc, (node) => {
    if (node.destination && node.destination.startsWith('nostr:')) {
      node.destination = node.destination.slice(6)
    }
  })
}

function resolveWikilinks(doc: any) {
  walk(doc, (node) => {
    if (node.tag !== 'link' && node.tag !== 'image') return
    if (node.destination) return
    if (!node.reference) return
    const defined = doc.references[node.reference] || doc.autoReferences?.[node.reference]
    if (defined?.destination) return
    const normalized = normalizeWikiDTag(node.reference)
    if (!normalized) return
    node.destination = `nostrwiki:${normalized}`
    delete node.reference
  })
}

function walk(node: any, visit: (node: any) => void) {
  if (!node || typeof node !== 'object') return
  visit(node)
  if (Array.isArray(node.children)) {
    for (const child of node.children) walk(child, visit)
  }
}
